import React, { useState } from "react";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../../components/common/forms/FormButtom";
// import FormPayment from "../../../../../components/common/forms/FormPayment";
import FormNewPayment from "../../../../../components/common/forms/FormNewPayment";
import { upload_document_v2 } from "./3MonthsReturnForm";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import ReusableNewCompany from "../common/ReusableNewCompany";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const NewCompanyForm = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);



  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)
  const [uploadProof, setUploadProof] = useState('')

  const handleSub = (data) => {
    data.documents = docsOutput;
    data.is_existing_company = true
    // const user = JSON.parse(localStorage.getItem("user"))

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID
      }
    }

    api
      .post(`services/company/`, data)
      .then((response) => {
        // console.log("success");
        // console.log(response.data);
        toast.success("Data Registered Successfully")

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   // amount: 2500,
        //   // amount: 0,
        //   service_object_id: response.data.registration_id,
        //   created_by: response.data.registration_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : response.data.company_id,
        //   transaction_type: "credit"

        // };


        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });


      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Data Registration Failed.");
      });

  };

  let data_v2 = [];
  upload_document_v2.map((item, i) => {
    data_v2.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      {/* Reusable company name */}
      <div className="flex justify-between">
        <p className="text-primary-blue font-Calistoga text-lg my-3 underline">
          1. Business Name & Other Details
        </p>
        <div className="mt-3">
          {

            (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer
              setUserId={setUserId}
            />
          }
        </div>
      </div>
      <ReusableNewCompany register={register} />
      {/* Reusable company close */}
      <div className="text-primary-blue font-Calistoga my-3 text-lg underline mt-4">
        2. Upload Document
        <span className="text-primary-blue underline">
          (३ महिने विवरण पेश गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
          गर्नुहोस ।)
        </span>
      </div>
      {/* new company for 3 months close */}
      {/* upload documents open */}
      <Documents
        documents_data={upload_document_v2}
        initialState={data_v2}
        setDocument={setDocsOutput}
      />
      <div className="text-primary-blue font-Calistoga my-3">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline text-base font-semibold mx-2">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
      <FormBranch register={register} />
      {/* <FormButtom /> */}
    
      <FormButtom/>

      
      <NewFormPayment handleSubmit={handleSubmit}
        handleClick={handleSub}
        setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default NewCompanyForm;
